import { ReactNode, createContext, useCallback, useContext, useState } from "react"

interface IComponentData {
   component: React.ComponentType | any;
}
interface IContextPanel {
   component: React.ComponentType | any;
   data: React.ComponentType | any;
   fatura: React.ComponentType | any;
   setComponent(component: IComponentData): void;
   setData(component: any): void;
   setFatura(component: any): void;
}

interface ContextProviderProps {
  children: ReactNode;
}

const PanelContext = createContext<IContextPanel>({} as IContextPanel );

const ContextPanelProvider: React.FC<ContextProviderProps> = ({ children }) => {
   const [ name, setName ] = useState<IComponentData>() 
   const [ data, setDataComponent ] = useState<any>() 
   const [ fatura, setDataFatura ] = useState<any>() 

   const setComponent = useCallback((e:any) => {
      setName(e);
   },[]);

   const setData = useCallback((e:any) => {
    setDataComponent(e);
 },[]);

 const setFatura = useCallback((e:any) => {
  setDataFatura(e);
},[]);

  return (
     <PanelContext.Provider
        value={{
          setComponent,
          setData,
          setFatura,
          component: name,
          data:data,
          fatura:fatura
        }}
      >
       {children}
    </PanelContext.Provider>
  )

}

function useContextPanel(): IContextPanel {
  const context = useContext(PanelContext);
  if(!context) {
    throw new Error(
      'useContextPanel must be used within an PanelContextProvider'
    )
  }
  return context;
}

export { ContextPanelProvider, useContextPanel }